import React, {useEffect, useState} from "react";
import { Form, Field } from "react-final-form";
import { Label } from "../../../shared/components/form/Layout";
import {NextButton, BackButton, ButtonArea} from "../../../shared/components/Buttons";
import { validate } from "../../../../data/booking/validators/end_user";
import FieldContainer from "../../../shared/containers/form/FieldContainer";
import ErrorContainer from "../../../shared/containers/form/ErrorContainer";
import Input from "../../../shared/components/form/Input";
import PhoneNumberInput from "../../../shared/components/form/PhoneNumberInput";
import Divider from "../../../shared/components/Divider";
import { useSelector } from "react-redux";

// import Number from "../../../shared/components/form/NumberInput";

import { useTranslation } from "react-i18next";
import {FormHeading} from "../../../shared/components/Typograhy";
import SlideInAnimation from "../../../shared/components/SlideInAnimation";

const EndUserForm = ({ isEditing, handleSubmit, onClickCancel, initialValues }) => {
    const { t } = useTranslation();
    const [show, setShow] = useState(false);
    const { contact } = useSelector(state => state.account.userSession.data)
    useEffect(() => {
        setShow(true);
    }, []);

    return (
        <SlideInAnimation show={show} appear={true}>
            <FormHeading title={isEditing ? t("booking.backpacker_information_edit") : t("booking.backpacker_information")} />
            <Form onSubmit={handleSubmit} validate={validate} initialValues={initialValues}>
                {({ handleSubmit, pristine, form, submitting, invalid }) => (
                    <form onSubmit={handleSubmit} className="">
                        <section className="px-4 pt-4">
                            <FieldContainer
                                form="end_user"
                                name="firstName"
                                className="mb-4"
                            >
                                <Label htmlFor="firstName" className="col-xs-3">
                                    {t("booking.first_name")} :{" "}
                                </Label>
                                <div className="col-xs-8 no-padding">
                                    <Field
                                        className="form-control"
                                        id="firstName"
                                        name="firstName"
                                        placeholder="ex: Michel"
                                        component={Input}
                                    />
                                    <ErrorContainer form="end_user" name="firstName" />
                                </div>
                            </FieldContainer>

                            <FieldContainer
                                form="end_user"
                                name="lastName"
                                className="mb-4"
                            >
                                <Label htmlFor="lastName" className="col-xs-3">
                                    {t("booking.last_name")} :{" "}
                                </Label>
                                <div className="col-xs-8 no-padding">
                                    <Field
                                        className="form-control"
                                        id="lastName"
                                        name="lastName"
                                        placeholder="ex: Chapuis"
                                        component={Input}
                                    />
                                    <ErrorContainer form="end_user" name="lastName" />
                                </div>
                            </FieldContainer>

                            <FieldContainer
                                form="end_user"
                                name="phoneNumber"
                                className="mb-4"
                            >
                                <Label htmlFor="phoneNumber" className="col-xs-3">
                                    {t("booking.phone")} :{" "}
                                </Label>
                                <div className="col-xs-8 no-padding">
                                    <Field
                                        className="form-control"
                                        id="phoneNumber"
                                        name="phoneNumber"
                                        placeholder={t("booking.phone")}
                                        component={PhoneNumberInput}
                                    />
                                    <ErrorContainer form="end_user" name="phoneNumber" />
                                </div>
                            </FieldContainer>

                            <Divider>{t("booking.agencyData")}</Divider>
                           
                            <FieldContainer
                                form="end_user"
                                name="clientId"
                                className="mb-4">
                                <Label htmlFor="clientId" className="col-xs-3">
                                    {t("booking.reservationLabel")} :{" "} 
                                </Label>
                                <div className="col-xs-8 no-padding">
                                    <Field
                                        className="form-control"
                                        id="clientId"
                                        name="clientId"
                                        placeholder="111-222"
                                        component={Input}
                                    />
                                    <ErrorContainer form="end_user" name="clientId" />
                                </div>
                            </FieldContainer>

                            <FieldContainer
                                form="end_user"
                                name="clientEmail"
                                className="mb-4">
                                <Label htmlFor="clientEmail" className="col-xs-3">
                                    {t("booking.clientEmail")}
                                </Label>
                                <div className="col-xs-8 no-padding">
                                    <Field
                                        className="form-control"
                                        id="clientEmail"
                                        name="clientEmail"
                                        placeholder={contact.email}
                                        component={Input}
                                    />
                                    <ErrorContainer form="end_user" name="clientEmail" />
                                </div>
                            </FieldContainer>

                        </section>
                        <ButtonArea>
                            {isEditing && (<BackButton onClick={onClickCancel}>
                                {t("booking.back")}
                            </BackButton>)}

                            <NextButton
                                classname="ml-auto"
                                disabled={pristine || submitting || invalid}
                                type="submit"
                            >
                                {isEditing ? t("booking.modify") : t("booking.validate")}
                            </NextButton>
                        </ButtonArea>
                    </form>
                )}
            </Form>
        </SlideInAnimation>
    );
};

export default EndUserForm;
